import React, { useMemo } from "react";
import { ArrowRightIcon, CheckIcon, CreditCardIcon, FileTextIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { ProductMockup } from "./ProductMockup";
import { offerIncludes } from "../data/landing";
import { productBrief } from "../data/productBrief";
import { getCheckoutUrl } from "../utils/checkout";
export function OfferSection() {
  const checkoutUrl = useMemo(() => getCheckoutUrl(), []);
  const openLicenseFaq = () => {
    const item = document.getElementById("faq-license");
    if (item instanceof HTMLDetailsElement) item.open = true;
  };
  return <section className="section offer-section" id="offer-details" aria-labelledby="offer-heading" data-id="element-69" data-mp="rdmwbmovc7vq">
      <div className="shell" data-id="element-70" data-mp="wby9o7edh0ip">
        <div className="section-intro" data-id="element-71" data-mp="wc80fx78rbpg">
          <p className="eyebrow" data-id="element-72" data-mp="2t5jbd6a8vzv9">THE PLANNING IS ALREADY DONE</p>
          <h2 id="offer-heading" data-id="element-73" data-mp="2t7dwaklinrzc">
            Your next team communication workshops.
            <br data-id="element-74" data-mp="2y4w4u9vmg56t" />
            <span data-id="element-75" data-mp="2y6gsdfjiqnv6">Already planned for you.</span>
          </h2>
        </div>
        <div className="offer-grid" data-id="element-76" data-mp="12p35136g1gnn">
          <div className="offer-contents" data-id="element-77" data-mp="xws6o4rcq2x7">
            <p className="eyebrow" data-id="element-78" data-mp="xvqs3qb4myaq">COMPLETE GUIDE · EVERYDAY TEAM COMMUNICATION</p>
            <h3 data-id="element-79" data-mp="swxgy4jbbjdq">{productBrief.brand}</h3>
            <p data-id="element-80" data-mp="sxyqg4kojxtc">
              The agendas, facilitator wording, role cards, examples and feedback sheets are already
              written. You get the complete guide with five complete workshop plans, printable participant
              materials and five bonuses to organize the practice around them.
            </p>
            <h4 data-id="element-81" data-mp="1glgq0ma6s06v">Your ready-to-run training plan includes</h4>
            <ul className="check-list" data-id="element-82" data-mp="1ckd6npsxjm0w">
              {offerIncludes.map(item => <li key={item} data-id="element-83" data-mp="17ljvw551294f">
                  <CheckIcon size={18} aria-hidden="true" data-id="element-84" data-mp="17mbn73rldkow" />
                  {item}
                </li>)}
            </ul>
            <h4 data-id="element-85" data-mp="3sd3sxopmb8xi">All five bonuses are included</h4>
            <ul className="bonus-checks" data-id="element-86" data-mp="3sb9aqi5qdux4">
              {productBrief.bonuses.map(bonus => <li key={bonus.number} data-id="element-87" data-mp="3tuiyqti8rgmx">
                  <CheckIcon size={16} aria-hidden="true" data-id="element-88" data-mp="2nooc51nczt6" />
                  {bonus.title}
                </li>)}
            </ul>
          </div>

          <div className="price-card" data-id="element-89" data-mp="3kt1m5l41lx2z">
            <ProductMockup data-id="element-90" data-mp="3oumuqu9jnp7d" />
            <p className="price-caption" data-id="element-91" data-mp="3otv9oddkp9vc">COMPLETE GUIDE · 5 WORKSHOPS + 5 BONUSES</p>
            <p className="offer-price" data-id="element-92" data-mp="3b2zwwpzye8mh">
              <span data-id="element-93" data-mp="3b1x4ueqwa04z">${productBrief.price.amountUsd}</span> USD
            </p>
            <p className="payment-note" data-id="element-94" data-mp="3fv9somnr22wo">One-time payment. No subscription.</p>
            <CtaButton href={checkoutUrl} data-id="element-95" data-mp="315u4neflsbko">
              Get my complete training plan <ArrowRightIcon size={18} aria-hidden="true" data-id="element-96" data-mp="364evin8ytiwg" />
            </CtaButton>
            <div className="delivery-details" data-id="element-97" data-mp="362cakhmo6fyl">
              <p data-id="element-98" data-mp="2s4dwldc9gljm">
                <CreditCardIcon size={17} aria-hidden="true" data-id="element-99" data-mp="2s5yoev76xqds" />
                Continue to the Impul store checkout
              </p>
              <p data-id="element-100" data-mp="2x5tjzc1wv456">
                <FileTextIcon size={17} aria-hidden="true" data-id="element-101" data-mp="2dhx80xukn3ls" />
                English PDFs + printable participant pages
              </p>
            </div>
            <p className="format-note" data-id="element-102" data-mp="28kf1fe4110gy">
              {productBrief.status}
              <br data-id="element-103" data-mp="2mjofa74rfihr" />
              Internal-team use. No video, slides, editable templates, software, certification or
              resale rights.
            </p>
            <a className="license-link" href="#faq-license" onClick={openLicenseFaq} data-id="element-104" data-mp="2wgt30be97m0o">
              Read format and license FAQs
            </a>
          </div>
        </div>
      </div>
    </section>;
}